import { useEffect } from "react";
import { resetQualtrics } from "../../utils/misc";

let previousIsScrollbarVisible = false;

const getIsScrollbarVisible = () => document.body.clientHeight > window.innerHeight;

export const useResetQualtrics = (depArray: unknown[]) => {
  useEffect(() => {
    const isScrollbarVisible = getIsScrollbarVisible();
    if (isScrollbarVisible !== previousIsScrollbarVisible) {
      previousIsScrollbarVisible = isScrollbarVisible;
      resetQualtrics();
    }
  }, depArray);
};
